import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromDefaultLookupActions from '../+state/actions/default-lookup.actions';
import { DefaultLookupResponse } from '../models/core-apis/default-lookup.interfaces';

@Injectable({ providedIn: 'root' })
export class DefaultLookupFacade {
  constructor(private store: Store) {}

  storeInputValues(
    cacheKeySuffix: string,
    triggerDefaultsLookupLanding: boolean,
    defaultLookupResponse: DefaultLookupResponse | null
  ) {
    this.store.dispatch(
      fromDefaultLookupActions.StoreDefaultLookupInputValues({
        cacheKeySuffix,
        triggerDefaultsLookupLanding,
        defaultLookupResponse
      })
    );
  }

  loadDefaultLookupLanding() {
    this.store.dispatch(fromDefaultLookupActions.LoadDefaultLookupLanding());
  }
}
